import {Route} from '@react-navigation/native';
import React from 'react';

export enum Screens {
  Main = 'main',
  MainTabs = 'mainTabs',
  DrawerMenu = 'drawerMenu',
  BottomTabsMenu = 'bottomTabsMenu',
  LoginScreens = 'loginScreens',
  Login = 'login',
  CardReissue = 'cardReissue',
  LoginConfirmation = 'loginConfirmation',
  EsiaRegistrationCard = 'esiaRegistrationCard',
  EsiaRegistrationCardUserSelecting = 'esiaRegistrationCardUserSelecting',
  EsiaRegistrationCardFormScreen = 'esiaRegistrationCardFormScreen',
  EsiaRegistrationCardMap = 'esiaRegistrationCardMap',
  EsiaActivateCard = 'esiaActivateCard',
  EsiaActivateCardAfterLogged = 'esiaActivateCardAfterLogged',
  EsiaLoginAfterLogged = 'esiaLoginAfterLogged',
  ProfileConfirmation = 'profileConfirmation',
  PinCodeAuthentication = 'pinCodeAuthentication',
  ChangeCityMobile = 'changeCityMobile',
  Profile = 'profile',
  CardServicesMenu = 'cardServicesMenu',
  CardServices = 'cardServices',
  TransportService = 'transportService',
  BankingService = 'bankingService',
  PrivilegesService = 'privilegesService',
  PrivilegesServiceDetails = 'privilegesServiceDetails',
  LoyaltyProgram = 'loyaltyProgram',
  LoyaltyProgramAcceptor = 'loyaltyProgramAcceptor',
  AcceptorsFilter = 'acceptorsFilter',
  SupportServiceTab = 'supportServiceTab',
  SupportService = 'supportService',
  SupportServiceTopics = 'supportServiceTopics',
  SupportServiceTopic = 'supportServiceTopic',
  SupportServiceCreateTopic = 'supportServiceCreateTopic',
  SupportServiceChatbot = 'supportServiceChatbot',
  PollsMenu = 'pollsMenu',
  Polls = 'polls',
  PollsTypeSurvey = 'pollsTypeSurvey',
  PollsTypeVote = 'pollsTypeVote',
  PollsTypeSurveyForm = 'pollsTypeSurveyForm',
  PollsTypeSurveyResult = 'pollsTypeSurveyResult',
  PollsTypeVoteForm = 'pollsTypeVoteForm',
  PollsTypeVoteResult = 'pollsTypeVoteResult',
  VisuallyImpairedSettings = 'visuallyImpairedSettings',
  AboutApplication = 'aboutApplication',

  QrCodeCard = 'qrCodeCard',

  SmsEmailSubscriptionControlScreen = 'SmsEmailSubscriptionControlScreen',
  SocialSupportMeasuresMenu = 'socialSupportMeasuresMenu',
  SocialSupportMeasures = 'socialSupportMeasures',
  StateAssignments = 'stateAssignments',
  StatePrograms = 'statePrograms',
  ExpenseLiabilities = 'expenseLiabilities',

  ProfileMenu = 'profileMenu',
  ProfileBaseInfo = 'profileBaseInfo',
  ProfileNotificationSettings = 'profileNotificationSettings',
  ProfileUserDocuments = 'profileDocuments',
  ProfileUserContacts = 'profileContacts',
  ProfileUserPhoneConfirmation = 'profileUserPhoneConfirmation',
  ProfileUserEmailConfirmation = 'profileUserEmailConfirmation',
  ProfileSafety = 'profileSafety',
  ProfileChangePassword = 'profileChangePassword',
  ProfileCreatePassword = 'profileCreatePassword',
  ProfileApplications = 'profileApplications',
  ProfileApplicationsFilter = 'profileApplicationsFilter',
  ProfileApplicationsItem = 'profileApplicationsItem',
  ProfileLinkedAccounts = 'profileLinkedAccounts',
  ProfileLinkedAccountsItem = 'profileLinkedAccountsItem',
  ProfileLinkedAccountsLinkAccount = 'profileLinkedAccountsLink',

  NotificationsMenu = 'notificationsMenu',
  Notifications = 'notifications',
  NotificationsItem = 'notificationsItem',

  MainNotificationsItem = 'mainNotificationsItem',

  DesktopProfileMe = 'desktopProfileMe',
  DesktopProfileSettings = 'desktopProfileSettings',
  DesktopProfileLinkedAccounts = 'desktopLinkedAccounts',

  WebView = 'webview',
  News = 'news',
  NewsArticle = 'newsArticle',
  VolunteersService = 'volunteersService',
  VolunteersServiceEvents = 'volunteersServiceEvents',
  VolunteersServiceExchangeHistory = 'volunteersServiceExchangeHistory',

  RewardShop = `rewardShop`,
  ProductItem = 'productItem',
  RewardShopFilters = 'rewardShopFilters',

  Cashback = 'cashBack',

  ECertificates = 'eCertificates',
  CertificateItem = 'certificateItem',

  Skipass = 'skipass',
}

export enum Routes {
  main = '/home/:tab?/:id?',
  mainMobile = '/home',
  login = '/login',
  cardReissue = '/card-reissue',
  confirmation = '/confirmation',
  loginConfirmation = '/login-confirmation',
  profileConfirmation = '/profile-confirmation',
  profile = '/profile',
  changeCityMobile = '/change-city',
  cardService = '/card-services',
  transportService = '/card-services/transport',
  bankingService = '/card-services/banking',
  privilegesService = '/card-services/privileges',
  privilegesServiceDetails = '/card-services/privileges/:smsCode',
  supportService = '/support-service',
  loyaltyProgram = '/card-services/loyalty-program',
  loyaltyProgramAcceptor = '/card-services/loyalty-program/acceptor/:id',
  acceptorsFilter = '/acceptors-filter',

  polls = '/polls',
  pollsTypeSurvey = '/polls/type-survey',
  pollsTypeVote = '/polls/type-vote',
  pollsTypeSurveyForm = '/polls/type-survey/:pollId',
  pollsTypeVoteForm = '/polls/type-vote/:pollId',

  visuallyImpairedSettings = '/visually-impaired-settings',
  aboutApplication = '/about-application',
  qrCodeCard = '/qr-code-card',

  socialSupportMeasures = '/social-support-measures',
  stateAssignments = '/social-support-measures/state-assignments',
  statePrograms = '/social-support-measures/state-programs',
  expenseLiabilities = '/social-support-measures/expense-liabilities',

  profileMenu = '/profile/menu',
  profileBaseInfo = '/profile/baseInfo',
  profileNotificationSettings = '/profile/notification-settings',
  profileUserDocuments = '/profile/documents',
  profileUserContacts = '/profile/contacts',
  profileUserPhoneConfirmation = '/profile/phone-confirmation',
  profileUserEmailConfirmation = '/profile/email-confirmation',
  profileChangePassword = '/profile/settings/change-password',
  profileCreatePassword = '/profile/settings/create-password/:code?',

  mobileNotifications = '/notifications',
  desktopNotifications = '/notifications/:id?',
  notificationsItem = '/notifications/:id',
  mainNotificationsItem = '/home/notifications/:id',

  smsEmailSubscriptionControlPath = '/unsubscribe',
  supportServiceTopicsDesktop = '/support-service/topics/:id?',
  supportServiceTopics = '/support-service/topics',
  supportServiceCreateTopic = '/support-service/topics/new',
  supportServiceTopic = '/support-service/topics/:id',
  supportServiceChatbot = '/support-service/chatbot',

  profileApplications = '/profile/applications/:application-id?',
  profileApplicationsFilter = '/profile/applications-filter',
  profileApplicationsItem = '/profile/applications/:application-id',

  profileMe = '/profile/me',
  profileSettings = '/profile/settings/:modal?',
  profileSafety = '/profile/safety',
  profileLinkedAccounts = '/profile/linkedaccounts',
  profileLinkedAccountsDesktop = '/profile/desk/linkedaccounts',
  profileLinkedAccountsItem = '/profile/linkedaccounts/:linkedaccount-id',
  profileLinkedAccountsLinkAccount = '/profile/linkedaccounts/link',

  webView = '/webview',

  drawer = '/drawer',
  news = '/news',
  newsArticle = '/news/:id',
  mainNewsArticle = '/main/news/:id',
  esiaActivateCard = '/esiaActivateCard',
  esiaActivateCardAfterLogged = 'esiaActivateCardAfterLogged/',
  esiaLoginAfterLogged = 'esiaLoginAfterLogged/',

  volunteersService = '/card-services/volunteers',
  volunteersServiceEvents = '/card-services/volunteers/events',
  volunteersServiceExchangeHistory = '/card-services/volunteers/history',

  rewardShop = `/card-services/rewardShop/:tabId?`,
  rewardShopFilters = `/card-services/rewardShop/filters/`,
  productItem = '/card-services/rewardShop/product/:id',

  cashBack = `/card-services/cashback/`,

  eCertificates = `/card-services/certificates/`,
  certificateItem = `/card-services/certificates/:id`,

  skipass = `/card-services/skipass/`,
}

export interface TabBarIconProps {
  focused: boolean;
  color: string;
  size: number;
  Icon: React.FC<{color: string; width?: number; height?: number}>;
  webRoute: Routes;
  routeName: Screens;
}

export interface NavigationRouteProps<T extends Object> extends Route<string> {
  params: T;
}
